import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Capacitor } from '@capacitor/core';
import { AppStartupService } from '@ridango/core';
import { Observable } from 'rxjs';

@Injectable()
export class TicketDeviceGuard implements CanActivate {
    private featureCode = 'WEB_RESTRICT_TICKET_VIEW_DEVICE';

    constructor(private appConfig: AppStartupService) {}

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
        if (!Capacitor.isNativePlatform() || !this.appConfig.doesPropertyExist(this.featureCode)) {
            return true;
        }
        // TODO: Will reimplement once BE supports multiple devices per customer
        return true;
    }
}
